'use strict';

const SelectOrganizationFormDirective = function ($timeout) {

  const link = (scope, el) => {

    el.addClass('full-height login-page-container');
    $timeout(() => {

      el[0].querySelector('[focus]').focus();
    }, 100);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    bindToController: true,
    controller: 'SelectOrganizationFormController',
    controllerAs: 'vm',
    link,
    templateUrl: 'login/selectOrganization/selectOrganization.tpl.html'
  };
};

SelectOrganizationFormDirective.$inject = ['$timeout'];
module.exports = SelectOrganizationFormDirective;



// WEBPACK FOOTER //
// ./src/app/login/selectOrganization/SelectOrganizationFormDirective.js